import React, { Component } from "react";

export default class Synopsis extends Component {
  render() {
    return (
      <div>
        <p>
          {/* <strong>
            <u>1. Radcliff Study </u>
          </strong>
          <br />
          <br /> */}
          <strong>
            <i>Study Status:</i>
          </strong>{" "}
          IRB Approved , Data Collection, Data Analysis
          <br />
          <br />
          <strong>
            <i>Study Design:</i>
          </strong>{" "}
          <br />
          The Radcliff Project is a multi-modal study focused on speech
          analytics, gait analysis and pulmonary function testing from People
          with Amyotrophic Lateral Sclerosis to find objective measures in
          prognosis and diagnosis of the disease. The study is completely
          remote; all assessments will be completed in the comfort of the
          participant’s home. The necessary equipment for the study will be sent
          directly to their front door, which comprises of: Spirometers for
          breathing tests, smart insoles for walking analysis, and an android
          smartphone. Proctors from the EverythingALS staff guide the
          participants through weekly to bi-weekly sessions to ensure quality
          while supporting participants. Data is captured and given directly to
          the participant via EverythingALS Participant Portal.
          <br />
          <br />
          <strong>
            <i>Recruitment:</i>
          </strong>
          <br /> Closed
        </p>
      </div>
    );
  }
}
